import React from 'react';
import { Flex, Popover } from 'antd';
import Button from '../button';

const RowActions = ({ actionsList = [], trigger = 'click' }) => {
  return (
    <Popover
      content={
        <Flex vertical gap={8}>
          {actionsList?.map((action) => {
            return action.show ? (
              <Button
                type={'link'}
                block
                onClick={() => action?.onClick()}
                icon={action?.icon}
                style={{ justifyContent: 'start' }}
              >
                {action?.title}
              </Button>
            ) : (
              <></>
            );
          })}
        </Flex>
      }
      trigger={trigger}
      placement={'left'}
    >
      <Button type={'link'} icon={'FiMoreVertical'} iconSize={16} shape={'circle'} size="small" />
    </Popover>
  );
};

export default RowActions;
